const validate = (inputs) => {

    const validEmailRegex = RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);
    let errors = {
        valid: true,
    };

    //name errors
    if (!inputs.name) {
        errors.nameError = 'Enter Name';
        errors.valid = false;
    } else if (!/^[a-zA-Z\s\-]+$/.test(inputs.name)) {
        errors.nameError = 'Name should contain only alphabets, spaces and hyphens';
        errors.valid = false;
    }
    //Email errors
    if (!validEmailRegex.test(inputs.email)) {
        errors.emailError = 'Enter a valid email ID';
        errors.valid = false;
    } else if (!inputs.email) {
        errors.emailError = 'Enter Email';
        errors.valid = false;
    }
    //Phone errors
    if (inputs.phone.length != 10) {
        errors.phoneError = 'Enter valid phone number'
        errors.valid = false;
    }

    //Password Errors
    if (inputs.password.length < 6) {
        errors.passwordError = 'Check Password'
        errors.valid = false;
    }
    if (!inputs.password) {
        errors.passwordError = 'Enter Password'
        errors.valid = false;
    }
    //Confirm Password Errors
    if (inputs.confirmPassword !== inputs.password) {
        errors.confirmPasswordError = 'Passwords do not match. Try again'
        errors.valid = false;
    }
    if (inputs.confirmPassword.length < 6) {
        errors.confirmPasswordError = 'Check Password'
        errors.valid = false;
    }
    if (!inputs.confirmPassword) {
        errors.confirmPasswordError = 'Enter Password'
        errors.valid = false;
    }

    return errors;
}
export default validate;